import React,{ useEffect, useState } from 'react';
import { history, useLocation } from 'umi';
import {Page } from 'react-weui';
import { Toast } from 'antd-mobile';
import styles from './styles.scss';
import Empty from '@/components/empty';

import { getMessageList,messageRead } from '@/services/myself';

export default () => {

  const [messageList,setMessageList] = useState([]);
  const [pageNo,setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数


  useEffect(()=>{
    getMessages(pageNo);
  },[]);

  function getMessages(page,resolve,finish) {
    getMessageList({pageNo:page,pageSize:20}).then(res =>{
      console.log(res);
      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (page == 1) {
          setMessageList(res.data.list);
        } else {
          setMessageList(prev => prev.concat(res.data.list));
        }
        setPageNo(page);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断

      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }

    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }

  return(
    <Page transition={true} ptr={false} infiniteLoader={true}
          onLoadMore={(resolve,finish) =>{
            if (messageList.length >= totalCount && totalCount !== 0) {
              finish();
              return;
            }
            getMessages(pageNo+1,resolve,finish);
          }}
    >

      {messageList.length ? messageList.map(item =>(
        <div className={styles.messageItem} key={item.id} onClick={()=>{

          history.push({pathname:'/myself/message/detail',state:{message:item}})

        }}>
          <label className={styles.messageTitle}>{item.title}</label>
          <label className={styles.messageTime}>{item.createDate}</label>

          {item.readStatus == '0' && <div className={styles.unRead}/>}

        </div>
      )) : <Empty text={'暂无消息'}/>}
      {messageList.length >= totalCount && totalCount !== 0 && (
        <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
          没有更多数据了
        </div>
      )}


    </Page>
  )


}
